import type { FC } from 'react';
import type { OfferBlockOption } from '../../../types/offer.types';
import { OfferBlockSelect } from '../../OfferBlock';
import { OfferTypeSelect } from '../../OfferType';
import { OfferTypeForm } from '../../OfferTypeForm';
import styles from '../OfferCreationForm.module.scss';

interface OfferSettingsSectionProps {
  offerBlocks: OfferBlockOption[];
  selectedBlockValue: string | number | null | undefined;
  onBlockChange: (value: string | number) => void;
}

export const OfferSettingsSection: FC<OfferSettingsSectionProps> = ({ offerBlocks, selectedBlockValue, onBlockChange }) => (
  <section className={`${styles.section} ${styles.offerSettings}`}>
    <div className={styles.ofertaTypeBlock}>
      <div>
        <p>Tipo de Oferta</p>
        <OfferTypeSelect />
      </div>
      <div>
        <p>Bloco de Ofertas</p>
        <OfferBlockSelect offerBlocks={offerBlocks} value={selectedBlockValue} onChange={onBlockChange} />
      </div>
    </div>
    <OfferTypeForm />
  </section>
);

OfferSettingsSection.displayName = 'OfferSettingsSection';
